import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction } from '../../serviceCall'

export const getTickets = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    formDataCommonFunction(data,apiConstants.TICKET.GET_TICKETS)
      .then((response) => {
        callback && callback(response.data)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
